import React from 'react';
import { Link, IndexLink } from 'react-router-dom';
import { connect } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import * as ImageUrl from "../../../constants/constant.js";
import * as constant from "../../../constants/constant.js";
import * as appointmentActions from '../../../actions/appointmentActions.js';
import * as disputeActions from '../../../actions/disputeActions.js';
import * as dashboardActions from "../../../actions/dashboardActions.js";
import * as signinActions from "../../../actions/signinActions";
import ReactLoading from 'react-loading';
import validator from '../../common/validator.js';
import { bindActionCreators } from 'redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Reaptcha from 'reaptcha';
import * as SVGICONS from '../../../images/img/images';
import OtpModal from '../../login/otp';
import moment from 'moment';
import '../../../styles/css/dispute.css'
import { Button, Form, FormGroup, Label, Input, Alert } from 'react-bootstrap';
import DisputeHeader from './disputeHeader.js';
import {
    Modal
} from 'react-bootstrap';
import DisputeFooter from './disputeFooter.js';
// {constant.PRODUCTION_IMAGE_URL + 'patientImage/' + image}
const size = 10;
let btnSize = { fontSize: '13' };
class DisputeLogin extends React.Component {
    constructor(props, context) {
        super(props);
        this.state = {
            logoutButton: false,
            disputeList: [],
            isLoader: false,
            forgotModalOpen: false,
            spinner: false,
            userType: { value: '1', isValid: true, message: '' },
            email: { value: '', isValid: true, message: '' },
            password: { value: '', isValid: true, message: '' },
            Ip: '',
            otpModalOpen: false,
            loginData: {},
            dispute: false

        };
        this.handleOutsideClick = this.handleOutsideClick.bind(this);
        this._logout = this._logout.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onSigninHandler = this.onSigninHandler.bind(this);
        this.Auth = this.Auth.bind(this);
		this.closeOtpModal = this.closeOtpModal.bind(this);

    }
    handleOutsideClick = (e) => {
        // ignore clicks on the component itself
        if (this.node && this.node.contains(e.target)) {
            return;
        }

        this.handleClick();
    }

    Auth() {
        var userAgentApplication = new Msal.UserAgentApplication('ab8fa067-8dfd-4dff-b453-db0b3f023f89', null, function (errorDes, token, error, tokenType) {
            // this callback is called after loginRedirect OR acquireTokenRedirect (not used for loginPopup/aquireTokenPopup)
        });

        return new Promise((resolve, reject) => {
            userAgentApplication.loginPopup(["user.read"]).then((token) => {
                if (token) {
                    var logindata = {
                        auth_user_name: userAgentApplication.getUser().displayableId,
                        auth_user_id: userAgentApplication.getUser().userIdentifier,
                        name: userAgentApplication.getUser().name,
                        company: "MedFix"
                    }
                    this.props.actions.signinUser(logindata, this.props);
                }
                else {
                    toastr.error("Some error occured please try again");
                }
                userAgentApplication.acquireTokenSilent(["user.read"]).then((token) => {
                    resolve(token);
                }, function (error) {
                    reject(error);
                });
            }, function (error) {
                reject(error);
            });
        });
    }

    handleClick = () => {
        if (!this.state.logoutButton) {
            // attach/remove event handler
            document.addEventListener('click', this.handleOutsideClick, false);
        } else {
            document.removeEventListener('click', this.handleOutsideClick, false);
        }

        this.setState(prevState => ({
            logoutButton: !prevState.logoutButton,
        }));
    }
    _logout(event) {

        let userId = localStorage.getItem("userId");
        this.props.actions.logout({ 'userId': userId });

        event.preventDefault();
        localStorage.clear();
        this.props.history.push("/");
    }
    viewRecipt = () => {

        this.props.disputeactions.viewReceipt({
            appointmentId: this.props.match.params.appointmentId,
            userLocation: moment.tz.guess(),
            patientId: this.props.history.location.data.data.patientId._id
            //  data passed via link router
        })
    }

    componentDidMount() {
        // let urlToRedirect = `disputes/${this.props.match.params.appointmentId}`
    }

    componentWillMount() {

        let objectDocument = {
            appointmentId: this.props.match.params.appointmentId
        }

        if (objectDocument) {
            // this.props.appointmentactions.getAppointmentDetails(objectDocument)
            this.props.disputeactions.getDisputeSubDisputeList();
        } else {
            // this.props.history.push('/')
        }
    }
    componentWillReceiveProps(nextProps) {

        console.log("sss", nextProps)
        // debugger;
        if (nextProps.signup) {

            this.setState({ spinner: false })
            this.props.hideSignupModal()
        } else {
            this.setState({ spinner: false })
        }
        if (nextProps.signin == 'failed') {
            this.setState({ spinner: false })

        }
        if (nextProps.signin && nextProps.signin.signin && nextProps.signin.signin.token && nextProps.signin.signin.token != '') {
            let loginData = {
                ...nextProps.signin.signin,
                signinData: {
                    email: this.state.email.value.toLowerCase(),
                    password: this.state.password.value,
                    userType: parseInt(this.state.userType.value),
                    Ip: this.state.Ip
                }
            }
            this.setState({
                loginData,
                otpModalOpen: true,
                dispute: true
            })

            // this.props.otpModal(loginData)
        }
    }

    searchDispute = (e) => {
        e.preventDefault()
        let searchTerm = this.state.searchTerm
        if (searchTerm) {
            // 
            // return;
            // this.props.history.match
            this.props.history.push({
                pathname: '/disputes/searchDisputelist',
                // search: `?query=${searchTerm}`,
                state: { searchTerm }
            })
            // this.props.disputeactions.searchDispute({searchTerm});
        }
    }
    resetValidationStates() {
        var state = this.state;
        Object.keys(state).map(key => {
            if (state[key].hasOwnProperty('isValid')) {
                state[key].isValid = true;
                state[key].message = '';
            }
        });
        this.setState(state);
    }

    onChange(e) {
        var state = this.state;
        state[e.target.name].value = e.target.value;
        this.resetValidationStates();
        if (e.target.name == "email") {
            if (e.target.value.length > 0) {
                if (!validator.isEmail(state.email.value)) {
                    state.email.isValid = false;
                    state.email.message = 'Not a valid email address';
                    this.setState(state);
                } else {
                    return true
                }
            } else {
                state.email.isValid = false;
                state.email.message = 'Email address is required';
                this.setState(state);
            }

        } else
            if (e.target.name == "password") {
                if (e.target.value.length > 0) {
                    if (!validator.isValid(state.password.value)) {
                        state.password.isValid = false;
                        state.password.message = 'Not a valid password';
                        this.setState(state);
                    } else {
                        return true
                    }
                } else {
                    state.password.isValid = false;
                    state.password.message = 'Password is required';
                    this.setState(state);
                }
            } else if (e.target.name == "userType") {
                return true
            }

        this.setState(state);
    }

    //Handler for sign-in
    onSigninHandler(event) {


        event.preventDefault();
        var state = this.state;
        if (!validator.isValid(parseInt(state.userType.value))) {
            state.userType.isValid = false;
            state.userType.message = 'Please select user type';
        } else {
            state.userType.isValid = true;
            state.userType.message = '';
        }
        if (!validator.isValid(state.email.value)) {
            state.email.isValid = false;
            state.email.message = 'Email address is required';
            this.setState(state);
        } else {
            state.email.isValid = true;
            state.email.message = '';
        }
        if (!validator.isValid(state.password.value)) {
            state.password.isValid = false;
            state.password.message = 'Password is required';
            this.setState(state);
        } else {
            state.password.isValid = true;
            state.password.message = '';
        }
        if (this.state.email.value != '' && this.state.password.value != '' && this.state.userType.value != '' && (this.state.email.message == '' || this.state.email.message == undefined) && (this.state.password.message == '' || this.state.password.message == undefined) && (this.state.userType.message == '' || this.state.userType.message == undefined)) {
            // debugger
            var signin = {
                email: this.state.email.value.toLowerCase(),
                password: this.state.password.value,
                userType: parseInt(this.state.userType.value),
                Ip: this.state.Ip
            }
            this.setState({ spinner: true })
            this.props.signinActions.signinUser(signin, this.props);

        }
    }

    closeOtpModal() {
        this.setState({ otpModalOpen: false });
    }

    render() {
        var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
        var { email, password } = this.state;
        if (user && user.gender == undefined) {
            user = { ...user, gender: 'Male' }
            // localStorage.setItem('user', JSON.stringify(user));
            // user = JSON.parse(localStorage.getItem("user"));
        }
        // var gender = localStorage.getItem('user')
        var defaultImagePath = (user && user.gender) == 'Male' ?
            constant.PRODUCTION_IMAGE_URL + "uploads/common/patient_m.png" : constant.PRODUCTION_IMAGE_URL + "uploads/common/patient_f.png";
        var imagePath = ''
        if (user && user.image == "noUserImage.jpg") {
            imagePath = user && user.gender == 'Male' ?
                constant.PRODUCTION_IMAGE_URL + "uploads/common/patient_m.png" : constant.PRODUCTION_IMAGE_URL + "uploads/common/patient_f.png";
        } else {
            imagePath =
                ImageUrl.PRODUCTION_IMAGE_URL +
                "uploads/" +
                localStorage.getItem("userId") +
                "/" +
                (user && user.image);
        }
        let rows = []
        if (this.state.disputeList && this.state.disputeList.length > 0) {
            this.state.disputeList.forEach(dispute => {
                let section =
                    <div key={dispute._id} className="col-md-4">
                        <div className="featureBlock d-flex">
                            {/* <div className="featureImg">  <img src={require('../../../images/stethoscope.svg')} alt=""  /></div> */}


                            <div className="featureLinks">
                                {<Link to={`/dispute/${this.props.match.params.appointmentId}/${dispute.dispute[0]._id}`}><h3>{dispute._id}</h3></Link>}
                                {dispute.subDisputes.map((subDisputes, i) => { return <Link to={`/dispute/${this.props.match.params.appointmentId}/${dispute.dispute[0]._id}/${subDisputes._id}`}><p>{subDisputes.title}</p></Link> }
                                )}
                            </div>

                        </div>


                    </div>
                rows.push(section)
            });
            // return rows
        } else {
            rows.push(<div className="col-md-6">
                Loading Dispute List
            </div>)

        }

        return (
            <div className="wrapper">
                {this.state.isLoader ? <div className="loaderCenter"> <ReactLoading type={'bars'} color={'blue'} /></div> :
                    (<React.Fragment>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-12">
                                    <DisputeHeader inputRef={el => this.inputElement = el} _logout={this._logout} handleClick={this.handleClick} logoutButton={this.state.logoutButton} />
                                </div>
                            </div>
                        </div>
                        {this.state.otpModalOpen ? <OtpModal otpModalOpen={this.state.otpModalOpen} loginData={this.state.loginData} closeOtpModal={this.closeOtpModal} {...this.props} dispute={this.state.dispute} /> : ''}

                        <div className="banner">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-md-8">
                                        <div className="banner-text">
                                            <h1>Having Trouble?</h1>
                                            <h1 className="sub-heading">We're here to help.</h1>
                                        </div>
                                        {/*  <form className="form-inline">
                                            <div className="form-group mt-4 d-flex">
                                                <input 
                                                type="text"
                                                className="form-control"
                                                placeholder="Describe your issue here"
                                                value={this.state.searchTerm}
                                                onChange={this.onChange}
                                                name="searchTerm"
                                                />
                                                <button
                                                className="btn btn-warning btn-lg"
                                                onClick={this.searchDispute}
                                                type="text"
                                                >Search</button>
                                            </div>
                                        </form> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                        </div>
                        <div className="user-profile">
                            <div className="container">
                                <div className="row">
                                    <form className="col-sm-4 offset-sm-4" id="loginForm" onSubmit={this.onSigninHandler} autoComplete="new-password">
                                        {/* <div className="signIn "><span className='signInWord'>Sign In </span> to your account</div>
                                        <p className="signUp">
                                            New to MedFix?
						<a href="#" onClick={this.props.closeSigninOpenSignup} style={{ cursor: 'pointer' }}>Sign Up for Free</a></p> */}
                                        <div className="userSpecialist">
                                            <div className="cc-selector">
                                                <input id="patient_img_radio" type="radio" name="userType" value="1" onChange={this.onChange} checked={this.state.userType.value === '1'} />
                                                <label className="drinkcard-cc userImg patient_img_radio" htmlFor="patient_img_radio"></label>
                                                {/* <input id="specialist_img_radio" type="radio" name="userType" value="2" onChange={this.onChange} checked={this.state.userType.value === '2'} />
                                                <label className="drinkcard-cc specialist_img_radio" htmlFor="specialist_img_radio"></label> */}
                                            </div>

                                        </div >
                                        <div className="loginInput">
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text" id="inputGroupPrepend">
                                                        <SVGICONS.EmailSvg />
                                                    </span>
                                                </div>
                                                <input autoComplete="new-password" type="text" name="email" className="form-control"
                                                    placeholder="Email Address" value={email.value} onChange={this.onChange} autoFocus />
                                                <span className="help-block">{email.message}</span>
                                            </div>
                                            {/* <ToastContainer /> */}
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text" id="inputGroupPrepend">
                                                        <SVGICONS.PasswordSvg />
                                                    </span>
                                                </div>
                                                <input autoComplete="new-password" type="password" name="password" className="form-control"
                                                    placeholder="Password" value={password.value} onChange={this.onChange} />
                                                <span className="help-block">{password.message}</span>
                                                {this.state.popoverShow == true ? <div className="toolTip">
                                                    <div className="tool_box">
                                                        <p>Password must Meet the following requirements: </p>
                                                        <ul>
                                                            <li>{this.state.patternOne == true ? <i className="fa fa-check-circle checkGreen"></i> : <i className="fa fa-close checkGreen checkRed"></i>} At least one letter</li>
                                                            <li>{this.state.patternTwo == true ? <i className="fa fa-check-circle checkGreen"></i> : <i className="fa fa-close checkGreen checkRed"></i>}At least one capital letter</li>
                                                            <li>{this.state.patternThree == true ? <i className="fa fa-check-circle checkGreen"></i> : <i className="fa fa-close checkGreen checkRed"></i>}At least one number</li>
                                                            <li>{this.state.patternFour == true ? <i className="fa fa-check-circle checkGreen"></i> : <i className="fa fa-close checkGreen checkRed"></i>}Be at least 8 characters	</li>
                                                        </ul>
                                                    </div>
                                                </div> : ''}
                                            </div>
                                            <div className="btngrouplogIn">
                                                <button className="btn btn-primary btn-signup" data-toggle="modal" type="submit" >Sign In{this.state.spinner ? <i className="fa fa-spinner fa-spin" /> : ""}</button>
                                            </div>
                                            {/* <Link to='/' onClick={this.props.openForgotModal} className="forgetPass" >
                                                Forgot Password?</Link> */}

                                        </div>
                                    </form>

                                    <div style={{ "text-align": "center" }} className="profile-details mb-5 offset-sm-4">
                                        <br /><br /><br />
                                        <span className="info">Or</span>
                                        <br /><br /><br />
                                        <span className="info">Visit our <Link to='/marketing/support-centre'>Support Center</Link> for Frequently asked questions</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <DisputeFooter />
                    </React.Fragment>
                    )}

            </div>
        );
    }
}
//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
    return {
        dispute: state.dispute,
        signin: state.signin

        // specialistPatients: state.specialist.specialistPatients
    };
}
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
    return {
        appointmentactions: bindActionCreators(appointmentActions, dispatch),
        disputeactions: bindActionCreators(disputeActions, dispatch),
        actions: bindActionCreators(dashboardActions, dispatch),
        signinActions: bindActionCreators(signinActions, dispatch),

    };
}
export default connect(mapStateToProps, mapDispatchToProps)(DisputeLogin);